import { FC } from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { usePagesDirectoryStableQueryParams } from '../../../../../../lib/adapters/next-routing-service/useUpdateQueryParam'
import { ProductDetailsContainer } from '../../contexts/ProductDetailsContainer'
import { FitsSection as GenericFitsSection } from '../FitsSection'

/**
 * @deprecated
 */
export const FitsSection: FC = () => {
  const {
    pages: { product: productPageStrings },
  } = useTranslation()
  const { updateQueryParams } = usePagesDirectoryStableQueryParams()

  const { category, fitKeys, fitNames, featuredProduct } = ProductDetailsContainer.useContainer()

  const { rawFit: selectedFitKey } = featuredProduct

  if (fitKeys.length === 0) return null
  return (
    <GenericFitsSection
      title={
        category === 'Scrub Top'
          ? productPageStrings.scrubTopsFitTitle
          : productPageStrings.scrubPantsFitTitle
      }
      fitKeys={fitKeys}
      fitNames={fitNames}
      selectedFitKey={selectedFitKey}
      onFitSelect={fitKey => {
        updateQueryParams({
          fit: fitKey,
        })
      }}
      disableMobileHorizontalSwipe
    />
  )
}
